import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Condenser from './Condenser';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Redirector from './Redirector';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Condenser />} />
        <Route path="/:id" element={<Redirector />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

